import * as React from "react";
import { useCallback } from "react";
import {
  ContentsHeader,
  DateRangeInput,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";
import { ProcedureSelect } from "../../../organisms/smart-apply/procedure-select";
import { CustomerReviewsContextProps } from "../../../../application/service/smart-apply/customer-reviews/customer-reviews-service";
import { useModal } from "../../../../utils/custom-hooks";
import { useRBAC } from "../../../helpers/rbac/use-rbac";

const CustomerReviewsContextKeys = [
  "selectedProcedure",
  "setDateRange",
  "searchCustomerReviews",
  "onCSVDownload",
  "onSelectProcedure",
] as const;

export const CustomerReviewHeader: React.FC<
  Pick<
    CustomerReviewsContextProps,
    (typeof CustomerReviewsContextKeys)[number]
  > & {
    menuToggle: ReturnType<typeof useModal>;
    dateFrom?: Date;
    dateTo?: Date;
  }
> = ({
  selectedProcedure,
  setDateRange,
  dateFrom,
  dateTo,
  searchCustomerReviews,
  onCSVDownload,
  onSelectProcedure,
}) => {
  const hasPermission = useRBAC();
  const setFilterValue = useCallback(
    ({
      startDate,
      endDate,
    }: {
      startDate: Date | null;
      endDate: Date | null;
    }) => {
      setDateRange({
        from: startDate ?? undefined,
        to: endDate ?? undefined,
      });
    },
    [setDateRange],
  );

  return (
    <ContentsHeader
      title={"申請者レビュー"}
      captionDirection="row"
      border={false}
      caption={
        hasPermission({
          requirePermissions: "customer_reviews.list",
        })
          ? [
              <div
                key={"customerReviewHeaderProcedureSelect"}
                data-testid="procedure-name"
                style={{
                  width: 320,
                }}
                className="customer-reviews-procedure-select"
              >
                <ProcedureSelect
                  selected={selectedProcedure}
                  onSelect={onSelectProcedure}
                />
              </div>,
              <DateRangeInput
                key={"customerReviewHeaderDateRangeInput"}
                startDate={dateFrom}
                endDate={dateTo}
                setValue={setFilterValue}
              />,
              <SecondaryButton
                key={"customerReviewHeaderUpdateButton"}
                text={"更新"}
                onClick={searchCustomerReviews}
              />,
            ]
          : undefined
      }
      buttons={
        hasPermission({
          requirePermissions: "customer_reviews.list",
        })
          ? [
              [
                <SecondaryButton
                  key={"customerReviewHeaderDownloadCSV"}
                  icon={"DownloadIcon"}
                  text={"CSV出力"}
                  onClick={onCSVDownload}
                />,
              ],
            ]
          : undefined
      }
    />
  );
};
